module.exports = __webpack_public_path__ + "static/img/yinpin.2f22c829.png";